import { useState } from 'react'
import { useLocation, useNavigate, useOutletContext } from 'react-router-dom'

import type { AtsJobApplicationConvertToEmployeePageFragment } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { apiClient } from 'modules/core/lib/mobx-rest'

import UnifiedAddEmployeeModal from 'modules/employees/components/UnifiedAddEmployeeModal'

interface OutletContext {
  application: AtsJobApplicationConvertToEmployeePageFragment
}

const JobApplicationConvertToEmployeePage = () => {
  const client = apiClient()
  const { application } = useOutletContext<OutletContext>()
  const [isSubmitting, setSubmitting] = useState(false)
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const { pathname } = useLocation()
  const previousPath = pathname.replace('/convert-to-employee', '')

  const onClose = () => navigate(previousPath)

  const onSuccess = (employeeId: number) => {
    setSubmitting(true)
    client.cache.evict('employees')
    client.cache.evict('users')
    navigate(navigation.employees.id.fullPath({ id: employeeId }))
  }

  if (isSubmitting) return null

  return (
    <UnifiedAddEmployeeModal
      initialValues={{
        firstName: application.candidate.firstName,
        lastName: application.candidate.lastName,
        email: application.candidate.email || undefined,
        teamId: application.jobPosting.teamId?.toString(),
        workplaceId: application.jobPosting.locationId?.toString(),
      }}
      source={{
        sourceType: 'ats_application',
        sourceId: application.id.toString(),
      }}
      onClose={onClose}
      onSuccess={onSuccess}
    />
  )
}

export default JobApplicationConvertToEmployeePage
